import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';

/**
 * Public runtime config exposed by the API — the SPA uses this to decide
 * whether the Auto-Campaign nav sub-tab appears at all, and to substitute
 * the bot username into the Telegram deep link.
 *
 * Backed by `GET /v1/config` (see apps/api/src/routes/health.ts).
 */
export interface RuntimeConfig {
  auto_campaign_enabled: boolean;
  telegram_bot_username: string | null;
}

export function useRuntimeConfig() {
  return useQuery({
    queryKey: ['runtime-config'],
    queryFn: () => apiGet<RuntimeConfig>('/v1/config'),
    // Config is effectively static per-deployment. Cache aggressively so we
    // don't refetch every navigation.
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
